import { z } from 'zod';

export const subscribeSchema = z.object({
    firstName: z.string().min(2, 'nameMustBeLonger'),
    lastName: z.string().min(2, 'lastNameMustBeLonger'),
    email: z.string().email('invalidEmail'),
});

export const checkoutSchema = z.object({
    email: z.string().email('invalidEmail'),
    promo: z.string().optional(),
});

export const signupSchema = z
    .object({
        firstName: z.string().min(2, 'nameMustBeLonger'),
        lastName: z.string().min(2, 'lastNameMustBeLonger'),
        email: z.string().email('invalidEmail'),
        phone: z.string().optional(),
        password: z.string().min(8, 'passwordMustBeLonger'),
        confirmPassword: z.string().min(8, 'passwordMustBeLonger'),
    })
    .refine((data) => data.password === data.confirmPassword, {
        message: 'passwordsDoNotMatch',
        path: ['confirmPassword'],
    });

export const loginSchema = z.object({
    email: z.string().email('invalidEmail'),
    password: z.string().min(8, 'passwordMustBeLonger'),
});

export const personalInfoSchema = z.object({
    firstName: z.string().min(2, 'nameMustBeLonger'),
    lastName: z.string().min(2, 'lastNameMustBeLonger'),
    pronouns: z.union([
        z.string().min(2, 'pronounsMustBeLonger'),
        z.literal(''),
    ]).optional(),
    email: z.string().email('invalidEmail'),
    phone: z.string().optional(),
    companyName: z.string().optional(),
    streetAddress: z.string().optional(),
    city: z.string().optional(),
    province: z.string().optional(),
    postalCode: z.string().optional(),
    country: z.string().optional(),
});

export const travelSchema = z.object({
    departureCountry: z.string(),
    departureDate: z.string(),
    departureTime: z.string(),
    departureFlightTrainNumber: z.string(),
    returnDate: z.string(),
    returnTime: z.string(),
    returnFlightTrainNumber: z.string(),
    hotelName: z.string(),
    hotelAddress: z.string(),
    howShouldWeContactYou: z.string(),
    firstName: z.string().min(2, 'nameMustBeLonger'),
    lastName: z.string().min(2, 'lastNameMustBeLonger'),
    nationality: z.string().min(2, 'nationalityMustBeLonger'),
    telephone: z.string(),
    address: z.string(),
    passportNumber: z.string().min(6, 'invalidPassportNumber').max(12, 'invalidPassportNumber'),
    dateOfBirth: z.string(),
    email: z.string().email('invalidEmail'),
    specialRequests: z.string().optional(),
});

export const filmmakerSchema = z.object({
    filmTitle: z.string(),
    filmRole: z.string(),
    instagram: z.string().optional(),
    facebook: z.string().optional(),
    tiktok: z.string().optional(),
    youtube: z.string().optional(),
    vimeo: z.string().optional(),
    linkedin: z.string().optional(),
    behance: z.string().optional(),
    website: z.string().optional(),
});

export const industrySchema = z.object({
    organizationName: z.string(),
    organizationRole: z.string(),
    instagram: z.string().optional(),
    facebook: z.string().optional(),
    tiktok: z.string().optional(),
    youtube: z.string().optional(),
    vimeo: z.string().optional(),
    linkedin: z.string().optional(),
    behance: z.string().optional(),
    website: z.string().optional(),
});

export const pressSchema = z.object({
    mediaName: z.string().min(1, 'Media name is required'),
    streetAddress: z.string().optional(),
    city: z.string().optional(),
    province: z.string().optional(),
    postalCode: z.string().optional(),
    country: z.string().optional(),
    email: z.string().email('Invalid email').optional(),
    headQuarterAddress: z.string().min(1, 'Headquarter address is required'),
    outreach: z.string().optional(),
    format: z.string().optional(),
    specification: z.string().optional(),
    website: z.string().url('Invalid URL').optional(),
    mediaDistribution: z.string().optional(),
    title: z.string().min(1, 'Title is required'),
    coveragePlan: z.string().optional(),
});

export const generalInfoSchema = z.object({
    firstName: z.string(),
    lastName: z.string(),
    pronouns: z.string(),
    email: z.string().email('InvalidEmail'),
    phone: z.string().min(6),
});

export const contactAddressSchema = z.object({
    street: z.string(),
    city: z.string(),
    province: z.string(),
    postalCode: z.string(),
    country: z.string(),
});

export const acceptInviteSchema = z
    .object({
        password: z.string().min(8, 'passwordMustBeLonger'),
        confirmPassword: z.string().min(8, 'passwordMustBeLonger'),
    })
    .refine((data) => data.password === data.confirmPassword, {
        message: 'passwordsDoNotMatch',
        path: ['confirmPassword'],
    });

// Audience Awards voting schemas
export const singleVoteSchema = z.object({
    category_id: z.string().uuid('Invalid category ID'),
    film_id: z.string().uuid('Invalid film ID'),
    rating: z.number().int().min(1, 'Rating must be at least 1').max(5, 'Rating must be at most 5'),
    ip_address: z.string().min(1, 'IP address is required'),
    user_agent: z.string().min(1, 'User agent is required'),
});

export const voteSubmissionSchema = z.object({
    votes: z.array(singleVoteSchema).min(1, 'At least one vote is required'),
    festivalId: z.string().uuid('Invalid festival ID'),
});
